import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PublishProps = IconComponentBaseProps;

export const Publish = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: PublishProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_4988_67668"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4988_67668)">
        <path
          d="M7.5 7.4L6.218 8.682C6.11878 8.78111 6.00106 8.83006 5.86483 8.82883C5.7285 8.8275 5.60861 8.77517 5.50517 8.67183C5.40861 8.56839 5.35861 8.45128 5.35517 8.3205C5.35172 8.18972 5.40172 8.07261 5.50517 7.96917L7.57817 5.89617C7.64061 5.83372 7.70644 5.78972 7.77567 5.76417C7.84489 5.7385 7.91967 5.72567 8 5.72567C8.08033 5.72567 8.15511 5.7385 8.22433 5.76417C8.29356 5.78972 8.35939 5.83372 8.42183 5.89617L10.4948 7.96917C10.5939 8.06839 10.6429 8.18444 10.6417 8.31733C10.6403 8.45022 10.5914 8.56839 10.4948 8.67183C10.3914 8.77517 10.2726 8.82856 10.1385 8.832C10.0043 8.83544 9.88544 8.78545 9.782 8.682L8.5 7.4V12.5C8.5 12.6419 8.45211 12.7607 8.35633 12.8563C8.26067 12.9521 8.14189 13 8 13C7.85811 13 7.73933 12.9521 7.64367 12.8563C7.54789 12.7607 7.5 12.6419 7.5 12.5V7.4ZM3 5.51283V4.20517C3 3.86839 3.11667 3.58333 3.35 3.35C3.58333 3.11667 3.86839 3 4.20517 3H11.7948C12.1316 3 12.4167 3.11667 12.65 3.35C12.8833 3.58333 13 3.86839 13 4.20517V5.51283C13 5.65472 12.9521 5.7735 12.8563 5.86917C12.7607 5.96494 12.6419 6.01283 12.5 6.01283C12.3581 6.01283 12.2393 5.96494 12.1437 5.86917C12.0479 5.7735 12 5.65472 12 5.51283V4.20517C12 4.15383 11.9786 4.10683 11.9358 4.06417C11.8932 4.02139 11.8462 4 11.7948 4H4.20517C4.15383 4 4.10683 4.02139 4.06417 4.06417C4.02139 4.10683 4 4.15383 4 4.20517V5.51283C4 5.65472 3.95211 5.7735 3.85633 5.86917C3.76067 5.96494 3.64189 6.01283 3.5 6.01283C3.35811 6.01283 3.23933 5.96494 3.14367 5.86917C3.04789 5.7735 3 5.65472 3 5.51283Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
